import axios from "axios";
import { 
    API_ENDPOINTS, 
    customToast, 
    route, 
    Variants 
} from "carrier-fe";
import { DocumentResourceType } from "../../types/documents";

export const approveDocument = async (
    setDisabled: (value: boolean) => void,
    closeModal: () => void,
    documentId: string
) => {
    setDisabled(true);
    try {
        const response = await axios.post(
            route(
                API_ENDPOINTS.GENERIC.DOCUMENT.APPROVE, {
                    document: documentId
                }
            )
        );
        customToast({
            title: response?.data?.message 
                || 'Document successfully approved',     
            variant: Variants.Success
        });
    } catch (error: any) {
        customToast({
            title: error?.response?.data?.message
                || 'Error approving document',
            variant: Variants.Danger
        });
    } finally {
        setDisabled(false);
        closeModal();
    }
};

export const rejectDocument = async (
    setDisabled: (value: boolean) => void,
    closeModal: () => void,
    documentId: string
) => {
    setDisabled(true);
    try {
        const response = await axios.post(
            route(
                API_ENDPOINTS.GENERIC.DOCUMENT.REJECT, {
                    document: documentId
                }
            )
        );
        customToast({
            title: response?.data?.message 
                || 'Document successfully rejected',
            variant: Variants.Success
        });
    } catch (error: any) {
        customToast({
            title: error?.response?.data?.message
                || 'Error rejecting document',
            variant: Variants.Danger
        });
    } finally {
        setDisabled(false);
        closeModal();
    }
};

export const deleteDocument = async (
    setDisabled: (value: boolean) => void,
    closeModal: () => void,
    documentId: string
) => {
    setDisabled(true);
    try {
        const response = await axios.delete(
            route(
                API_ENDPOINTS.GENERIC.DOCUMENT.DELETE, {
                    document: documentId
                }
            )
        );
        customToast({
            title: response?.data?.message 
                || 'Document successfully deleted',
            variant: Variants.Success
        });
    } catch (error: any) {
        customToast({
            title: error?.response?.data?.message
                || 'Error deleting document',
            variant: Variants.Danger
        });
    } finally {
        setDisabled(false);
        closeModal();
    }
};

export const downloadAll = async (
    setDisabled: (value: boolean) => void,
    closeModal: () => void,
    companyDocument: Partial<DocumentResourceType>
) => {
    const { id, company_name, document_type } = companyDocument;
    setDisabled(true);
    try {
        const response = await axios.get(
            route(
                API_ENDPOINTS.GENERIC.DOCUMENT.DOWNLOAD, {
                    document: id || ''
                }
            ),
            {
                responseType: 'blob',
            }
        );

        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = `${company_name}_${document_type}.zip`;
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error: any) {
        customToast({
            title: error?.response?.data?.message
                || 'Error downloading files',
            variant: Variants.Danger
        });
    } finally {
        setDisabled(false);
        closeModal();
    }
};
